<template>
  <div class="pagination">
    <div class="el-pagination is-background">
      <button type="button" v-if="pageNum <= pagers[0]" disabled="disabled" class="btn-prev"><i class="el-icon el-icon-d-arrow-left"></i></button>
      <button type="button" @click="doClickItem(1)" v-else class="btn-prev"><i class="el-icon el-icon-d-arrow-left"></i></button>
      <button type="button" v-if="pageNum <= pagers[0]" disabled="disabled" class="btn-prev"><i class="el-icon el-icon-arrow-left"></i></button>
      <button type="button" @click="doPrevClick" v-else class="btn-prev"><i class="el-icon el-icon-arrow-left"></i></button>
      <ul class="el-pager">
        <li v-for="(item, index) in pagers" @click="doClickItem(item)" :key="index" class="number" :class="{active: item == pageNum}">{{item}}</li>
      </ul>
      <button type="button" v-if="pageNum >= pagers[pagers.length - 1]" disabled="disabled" class="btn-next"><i class="el-icon el-icon-arrow-right"></i></button>
      <button type="button" @click="doNextClick" v-else class="btn-next"><i class="el-icon el-icon-arrow-right"></i></button>

      <el-select class="unlockPageSize" v-if="indexPg" v-model="inPageSize" @change="sizeChange">
        <el-option
          v-for="item in pageSizes"
          :key="item"
          :label="item + '条/页'"
          :value="item">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paginationNew',
  props: {
    pageNum: {
      type: Number,
      default: 1
    },
    maxPageNum: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 9
    },
    pageSize: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default: () => [20,40,100,500]
    },
    indexPg:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      inPageSize: 20
    }
  },
  watch:{
    pageSize: {
      immediate: true,
      handler: function (val) {
        this.inPageSize = val
      }
    },
  },
  computed: {
    pagers() {
      const half = Math.floor(this.limit / 2)
      let end = Math.min(this.maxPageNum, this.pageNum + half)
      
      const start = Math.max(end - this.limit + 1, 1)
      end = Math.min(this.maxPageNum, start + this.limit - 1)
     
      let arr = []
      for (let i = start; i <= end; i++) {
        arr.push(i)
      }
      return arr
    }
  },
  methods: {
    doClickItem(item) {
      if (this.pageNum == item) return
      this.currentChange(item)
    },
    doPrevClick() {
      this.currentChange(Math.max(1, this.pageNum - 1))
    },
    doNextClick() {
      this.currentChange(Math.min(this.maxPageNum, this.pageNum + 1))
    },
    currentChange(val) {
      this.$emit('currentChange', val)
    },
    sizeChange (val) {
      this.$emit('sizeChange', val)
    }
  },
  mounted() {
  }
}
</script>

<style lang='scss' rel='stylesheet/scss' scoped>
.pagination {
  text-align: right;
  // background-color: #fff;
  border-radius: 0 0 4px 4px;
  padding: 16px;
}
.pagination /deep/ .el-pagination {
  font-weight: 400;
}
.pagination /deep/ .el-pagination.is-background .el-pager li {
  // background-color: #fff;
  // border: 1px solid #dcdfe6;
      // color: #606266;
}
.pagination
  /deep/
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #5088FF;
  // border: 1px solid #5088FF;
  // box-shadow: 0px 2px 10px 0px rgba(237,104,38,0.1000);
}
.pagination /deep/ .el-pagination.is-background .btn-next {
  background-color: #fff;
  // border: 1px solid #dcdfe6;
}
.pagination /deep/ .el-pagination.is-background .btn-prev {
  background-color: #fff;
  // border: 1px solid #dcdfe6;
}
.pagination /deep/ .el-pagination.is-background .el-icon {
  font-weight: 400;
  font-size: 16px;
}
::v-deep{
      .el-pagination .el-select.unlockPageSize .el-input .el-input__inner{
        background: #FFFFFF;
        width: 100%;
        height: 32px;
      }
      .el-pagination .el-select.unlockPageSize{
        height: 32px;
        width: 89px;
        margin-right: 5px;
      }
      .el-pagination .el-select.unlockPageSize .el-input--suffix{
          width: 89px;
      }
      .el-pagination.is-background .btn-next{
         margin-right: 10px;
      }
}
</style>
